// Breakpoint values in pixels
export const BREAKPOINTS = {
  MOBILE_NARROW: '679px',
  MOBILE: '896px',
};
